export type PermissionType = {
  id: string;
  name: string;
  description: string;
};

export const typePermissions = <const>['create', 'read', 'update', 'delete'];
